<p>catalogue-management works!</p>
